var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg7 = function Svg7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4E5969",
    fillRule: "evenodd",
    d: "M4.5 2.25A2.25 2.25 0 0 0 2.25 4.5v15a2.25 2.25 0 0 0 2.25 2.25h15a2.25 2.25 0 0 0 2.25-2.25v-15a2.25 2.25 0 0 0-2.25-2.25zM3.75 4.5a.75.75 0 0 1 .75-.75h6.75v3.5h-7.5zM19.5 20.25a.75.75 0 0 0 .75-.75v-2.75h-7.5v3.5zm-8.25 0V8.75h-7.5V19.5c0 .414.336.75.75.75zm1.5-16.5h6.75a.75.75 0 0 1 .75.75v10.75h-7.5z",
    clipRule: "evenodd"
  })));
};
export default Svg7;